const Esslattendence = () => {
  const labels = [
    "Registered Employees",
    "Active Employees",
    "Present Employees",
    "Online Devices",
    "Offline Devices",
  ];

  const colors = [
    "#4CAF50", // Green
    "#2196F3", // Blue
    "#FF9800", // Orange
    "#9C27B0", // Purple
    "#F44336", // Red
  ];

  // Generate random numbers for each box
  const randomValues = labels.map(() => Math.floor(Math.random() * 100));

  return (
    <div style={{ padding: "20px" }}>
      {/* Dashboard Header */}
      <h2 style={{ marginBottom: "20px", fontWeight: "bold" }}>Dashboard</h2>

      {/* Boxes Row */}
      <div style={{ display: "flex", gap: "10px" }}>
        {labels.map((label, index) => (
          <div
            key={index}
            style={{
              width: "250px",
              height: "100px",
              backgroundColor: colors[index],
              borderRadius: "6px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              padding: "10px",
              color: "white",
              fontSize: "15px",
              fontWeight: "bold",
            }}
          >
            {label}
            <span style={{ fontSize: "24px", marginTop: "5px" }}>
              {randomValues[index]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Esslattendence;
